// @ts-nocheck
const TextFragmentComponent = ({ children }) => children;

export default TextFragmentComponent;
